export default __webpack_public_path__ + "static/media/menu-logo.3ed57e9e.png";